import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { getDecisionMakerConfigs } from 'src/app/pages/petitionDetails/shared/api';

export async function isUserEligibleForLegislativeBodies(
	utilityContext: UtilityContext,
	{
		hasShowLegislativeBodiesParam,
	}: {
		hasShowLegislativeBodiesParam: boolean;
	},
): Promise<boolean> {
	if (hasShowLegislativeBodiesParam) return true;

	const { legislativeBodiesEnabled } = await getDecisionMakerConfigs(utilityContext);

	return legislativeBodiesEnabled;
}
